module.exports = __webpack_public_path__ + "static/blog62-b6131b11cc644aea075588b78308d77e.png";